import { apiCall } from '../utils';
import { FORM_API, FORM_TYPE } from '../constants';

import { userActions } from '.';
const { notification } = userActions;

export const formActions = {
  insertApplicationForm,
  updateApplicationForm,
  filterApplicationForm,
  filterApplicationFormSearch,
  approveApplicationForm,
  getApplicationByProfileId,
  setFocusForm,
  updateFocusForm,
  updateFocusFormByData,
  thongKe,
  updateBCD,
  getApplicationFormv2,
  reloadSeasonAchievements,
};

function getApplicationByProfileId(id) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.getApplicationByProfileId(id);
    const { response, error } = await apiCall({ ...api });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      // dispatch(notification({ message: 'Lấy thông tin hồ sơ thành công', type: 'success' }));
    } else {
      dispatch(failure(error));
      dispatch(notification({ message: 'Lấy thông tin hồ sơ thất bại', type: 'error' }));
    }
  };

  function loading() {
    return { type: FORM_TYPE.GET_APPLICATION_BY_PROFILE_ID_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.GET_APPLICATION_BY_PROFILE_ID_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.GET_APPLICATION_BY_PROFILE_ID_FAILURE, error };
  }
}

function getApplicationFormv2(id) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.getApplicationFormv2(id);
    const { response, error } = await apiCall({ ...api });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      // dispatch(notification({ message: 'Lấy thông tin hồ sơ thành công', type: 'success' }));
    } else {
      dispatch(failure(error));
      dispatch(notification({ message: 'Lấy thông tin hồ sơ thất bại', type: 'error' }));
    }
  };

  function loading() {
    return { type: FORM_TYPE.GET_APPLICATION_FORM_V2_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.GET_APPLICATION_FORM_V2_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.GET_APPLICATION_FORM_V2_FAILURE, error };
  }
}

// Nạp danh sách thành tích (7 loại) CHỈ của 1 season, thay cho
// getApplicationFormv2/getXxxByProfileId (lấy TẤT CẢ các season ứng viên
// từng đăng ký, không phân biệt mùa giải -> nếu 1 người đăng ký nhiều
// season, lưu hồ sơ season này sẽ vô tình gắn nhầm thành tích của season
// khác vào). Dùng lại /form/filter (đã lọc đúng season qua Preload ở
// backend), dựng lại 7 mảng phẳng đúng shape mà các reducer đang chờ ở
// case GET_APPLICATION_FORM_V2_SUCCESS.
function reloadSeasonAchievements(profileId, seasonId, category) {
  return async (dispatch) => {
    dispatch({ type: FORM_TYPE.GET_APPLICATION_FORM_V2_LOADING });

    const api = FORM_API.filterApplicationForm();
    const { response, error } = await apiCall({
      ...api,
      payload: { category, seasonId, profileId },
    });

    if (!error && response.status === 200 && response.data.success) {
      const application = response.data.data?.[0];

      // Ghép nested join-table record thành 1 achievement "phẳng", giữ lại
      // score/maxScore/accepted/note/id của bảng nối (cùng shape với chỗ khác
      // trong app đang dựng detail từ application form, vd HoSoDetail.js).
      // maxScore (khung điểm hội đồng đã chỉnh) BẮT BUỘC phải có ở đây: form
      // Đăng ký hồ sơ gửi ngược danh sách này lên /form/update, mà backend xoá
      // rồi tạo lại toàn bộ bảng nối -> thiếu trường nào là mất trường đó.
      const flatten = (formKey, achievementKey) =>
        (application?.[formKey] || []).map((f) => ({
          ...f[achievementKey],
          note: f.note,
          score: f.score,
          maxScore: f.maxScore,
          accepted: f.accepted,
          [`${formKey}Id`]: f.id,
          thanhTichAccepted: f.accepted,
        }));

      const payload = {
        scientificResearches: flatten('formScientificResearch', 'scientificResearch'),
        scientificReports: flatten('formScientificReport', 'scientificReport'),
        monographs: flatten('formMonograph', 'monograph'),
        researchProjects: flatten('formResearchProject', 'researchProject'),
        solutions: flatten('formSolution', 'solution'),
        rewards: flatten('formReward', 'reward'),
        techCompanies: flatten('formTechCompany', 'techCompany'),
        // hrDevelopmentReducer cũng lắng nghe GET_APPLICATION_FORM_V2_SUCCESS
        // và gọi thẳng action.payload.hrDevelopments.sort(...) không optional
        // chaining - thiếu field này sẽ throw TypeError, làm dispatch() ném lỗi
        // giữa chừng khiến CẢ 7 loại thành tích phía trên KHÔNG được cập nhật
        // vào Redux (combineReducers thất bại toàn bộ cho action này) - dù
        // API đã trả dữ liệu đúng. Đây là nguyên nhân UI hiện trống rồi khi
        // lưu lại xoá mất thành tích thật trong DB.
        hrDevelopments: flatten('formHrDevelopment', 'hrDevelopment'),
      };

      dispatch({ type: FORM_TYPE.GET_APPLICATION_FORM_V2_SUCCESS, payload });
      return payload;
    } else {
      dispatch({ type: FORM_TYPE.GET_APPLICATION_FORM_V2_FAILURE, error });
      dispatch(notification({ message: 'Lấy thông tin thành tích thất bại', type: 'error' }));
      return false;
    }
  };
}

function filterApplicationForm(payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.filterApplicationForm();
    const { response, error } = await apiCall({ ...api, payload });

    if (!error && response.status === 200 && response.data.success) {
      if (response.data.data.length > 0) {
        dispatch(success(response.data.data));
      } else {
        dispatch(success([]));
      }
      // dispatch(notification({ message: 'Lấy thông tin hồ sơ thành công', type: 'success' }));
      return response.data.data;
    } else {
      dispatch(failure(error));
      dispatch(notification({ message: 'Lấy thông tin hồ sơ thất bại', type: 'error' }));
      return false;
    }
  };

  function loading() {
    return { type: FORM_TYPE.FILTER_APPLICATION_FORM_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.FILTER_APPLICATION_FORM_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.FILTER_APPLICATION_FORM_FAILURE, error };
  }
}

function filterApplicationFormSearch(payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.filterApplicationForm();
    const { response, error } = await apiCall({ ...api, payload });

    if (!error && response.status === 200 && response.data.success) {
      if (response.data.data.length > 0) {
        dispatch(success(response.data.data));
      } else {
        dispatch(success(null));
      }
      return response.data.data;
    } else {
      dispatch(failure(error));
      return false;
    }
  };

  function loading() {
    return { type: FORM_TYPE.FILTER_APPLICATION_FORM_SEARCH_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.FILTER_APPLICATION_FORM_SEARCH_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.FILTER_APPLICATION_FORM_SEARCH_FAILURE, error };
  }
}

function insertApplicationForm(payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.insertApplicationForm();
    const { response, error } = await apiCall({ ...api, payload });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      dispatch(notification({ message: 'Cập nhật thông tin hồ sơ thành công', type: 'success' }));
      return true;
    } else {
      dispatch(failure(error));
      dispatch(notification({ message: 'Cập nhật thông tin hồ sơ thất bại', type: 'error' }));
      return false;
    }
  };

  function loading() {
    return { type: FORM_TYPE.INSERT_APPLICATION_FORM_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.INSERT_APPLICATION_FORM_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.INSERT_APPLICATION_FORM_FAILURE, error };
  }
}

function updateApplicationForm(payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.updateApplicationForm();
    const { response, error } = await apiCall({ ...api, payload });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      dispatch(notification({ message: 'Cập nhật thông tin hồ sơ thành công', type: 'success' }));
      return true;
    } else {
      dispatch(failure(error));
      dispatch(notification({ message: 'Cập nhật thông tin hồ sơ thất bại', type: 'error' }));
      return false;
    }
  };

  function loading() {
    return { type: FORM_TYPE.UPDATE_APPLICATION_FORM_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.UPDATE_APPLICATION_FORM_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.UPDATE_APPLICATION_FORM_FAILURE, error };
  }
}

function approveApplicationForm(id, payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.approveApplicationForm(id);
    const { response, error } = await apiCall({ ...api, payload });

    const message = payload.status === 'need_update' ? 'Ghi chú hồ sơ' : 'Xác nhận hồ sơ';

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));

      dispatch(notification({ message: `${message} thành công`, type: 'success' }));
    } else {
      dispatch(failure(error));
      dispatch(notification({ message: `${message} thất bại`, type: 'error' }));
    }
  };

  function loading() {
    return { type: FORM_TYPE.UPDATE_APPLICATION_FORM_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.UPDATE_APPLICATION_FORM_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.UPDATE_APPLICATION_FORM_FAILURE, error };
  }
}

function thongKe(seasonId) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.thongKe(seasonId);
    const { response, error } = await apiCall({ ...api });
    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
    } else {
      dispatch(failure(error));
    }
  };

  function loading() {
    return { type: FORM_TYPE.THONG_KE_TAI_KHOAN_LOADING };
  }
  function success(payload) {
    return { type: FORM_TYPE.THONG_KE_TAI_KHOAN_SUCCESS, payload };
  }
  function failure(error) {
    return { type: FORM_TYPE.THONG_KE_TAI_KHOAN_FAILURE, error };
  }
}

function updateBCD(payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = FORM_API.updateBCD();
    const { response, error } = await apiCall({ ...api, payload });
    if (!error && response.status === 200 && response.data.success) {
      dispatch(notification({ message: 'Duyệt hồ sơ thành công', type: 'success' }));
      setTimeout(() => window.location.reload(), 1000);
    } else {
      dispatch(notification({ message: 'Duyệt hồ sơ thất bại', type: 'error' }));
    }
  };

  function loading() {
    return { type: FORM_TYPE.UPDATE_BCD_APPLICATION_FORM_LOADING };
  }
}

function setFocusForm(form) {
  return { type: FORM_TYPE.SET_FOCUS_FORM, payload: form };
}

function updateFocusForm(name, payload) {
  return { type: FORM_TYPE.UPDATE_FOCUS_FORM, name, payload };
}

function updateFocusFormByData(name, child, payload) {
  return { type: 'UPDATE_FOCUS_FORM_BY_DATA', name, child, payload };
}
